import styled from 'styled-components';

export const Container = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* cursor: help; */
  margin-left: 4px;
`;

export const InfoIcon = styled.i`
  font-size: 14px !important;
  color: ${props => (props.isDarkTheme ? 'rgba(255, 255, 255, 0.6)' : 'rgba(103, 150, 207, 0.7)')};
  transition: color 0.2s ease;
  user-select: none;

  &:hover {
    color: ${props => (props.isDarkTheme ? 'rgba(255, 255, 255, 0.9)' : 'rgba(103, 150, 207, 1)')};
  }
`;
